(function () {
  'use strict';

  var debounceTimer = null;
  var processing = false;
  var pauseCartHooks = 0;
  var skipNextCartUpdatedSync = false;
  var LEGACY_SAMPLE_THRESHOLD = 3;

  function getConfig() {
    return window.theme && window.theme.pickMixExtras;
  }

  function isCartPage() {
    var path = window.location.pathname.replace(/\/$/, '') || '/';
    return path === '/cart';
  }

  function refreshThemeCartUI() {
    var instances =
      window.Shopify &&
      window.Shopify.theme &&
      window.Shopify.theme.sections &&
      window.Shopify.theme.sections.instances;

    if (instances && instances.length) {
      instances.forEach(function (instance) {
        if (instance.type === 'cart' && typeof instance.refreshCart === 'function') {
          instance.refreshCart();
        }
        if (instance.type === 'quick-cart' && typeof instance.refreshQuickCart === 'function') {
          instance.refreshQuickCart();
        }
      });
      return;
    }

    refreshCartSectionsFallback();
  }

  function refreshCartSectionsFallback() {
    var base =
      window.theme && window.theme.routes && window.theme.routes.cart && window.theme.routes.cart.base
        ? window.theme.routes.cart.base
        : '/cart';

    var cartEl = document.querySelector('[data-section-type="cart"]');
    if (cartEl) {
      var cartSectionId = cartEl.getAttribute('data-section-id');
      fetch(base + '?section_id=' + cartSectionId)
        .then(function (res) {
          return res.text();
        })
        .then(function (html) {
          var wrap = document.createElement('div');
          wrap.innerHTML = html;
          cartEl.innerHTML = wrap.innerHTML;
        })
        .catch(function () {});
    }

    var quickEl = document.querySelector('[data-section-type="quick-cart"]');
    if (quickEl) {
      var quickSectionId = quickEl.getAttribute('data-section-id');
      fetch(base + '?section_id=' + quickSectionId)
        .then(function (res) {
          return res.text();
        })
        .then(function (html) {
          var wrap = document.createElement('div');
          wrap.innerHTML = html;
          var inner = wrap.querySelector('[data-section-type="quick-cart"]');
          quickEl.innerHTML = inner ? inner.innerHTML : wrap.innerHTML;
        })
        .catch(function () {});
    }
  }

  function dispatchCartUpdated(cart) {
    if (!cart) return;
    if (window.theme) window.theme.cartData = cart;

    skipNextCartUpdatedSync = true;
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    skipNextCartUpdatedSync = false;

    refreshThemeCartUI();
  }


  function hasVariantInCart(cart, variantId) {
    if (!variantId) return false;
    var id = Number(variantId);
    return cart.items.some(function (item) {
      return Number(item.variant_id) === id;
    });
  }

  function lineItemsWithVariant(cart, variantId) {
    var id = Number(variantId);
    return cart.items.filter(function (item) {
      return Number(item.variant_id) === id;
    });
  }

  function bundleLinesInCart(cart, bundleProductId) {
    if (!bundleProductId) return [];
    var productId = Number(bundleProductId);
    return cart.items.filter(function (item) {
      return Number(item.product_id) === productId;
    });
  }

  function legacySampleQuantityInCart(cart) {
    var count = 0;
    cart.items.forEach(function (item) {
      if (item.title && item.title.toLowerCase().indexOf('sample') > -1) {
        count += item.quantity;
      }
    });
    return count;
  }

  function qualifiesForPickMix(cart, config) {
    if (config.bundleProductId && bundleLinesInCart(cart, config.bundleProductId).length) {
      return true;
    }
    return legacySampleQuantityInCart(cart) >= LEGACY_SAMPLE_THRESHOLD;
  }

  function hasSampleInProperties(lineItem) {
    var props = lineItem.properties || {};
    return Object.keys(props).some(function (key) {
      if (key.charAt(0) === '_') return false;
      var value = props[key];
      if (value == null || value === '') return false;
      return String(value).toLowerCase().indexOf('sample') > -1;
    });
  }

  function getIngredientsVariantId(cart, config) {
    if (
      config &&
      config.bundleProductId &&
      bundleLinesInCart(cart, config.bundleProductId).length &&
      config.ingredientsTravelVariantId
    ) {
      return config.ingredientsTravelVariantId;
    }

    return config && config.ingredientsVariantId;
  }

  function bundleHasSampleInProperties(cart, config) {
    if (!config || !config.bundleProductId) return false;
    var bundles = bundleLinesInCart(cart, config.bundleProductId);
    return bundles.length > 0 && bundles.some(hasSampleInProperties);
  }

  function hasSampleTitleInCart(cart, config) {
    var ingredientsVariantId = config && config.ingredientsVariantId;
    return cart.items.some(function (item) {
      if (ingredientsVariantId && Number(item.variant_id) === Number(ingredientsVariantId)) {
        return false;
      }
      return item.title && item.title.toLowerCase().indexOf('sample') > -1;
    });
  }

  function shouldHaveIngredients(cart, config) {
    return hasSampleTitleInCart(cart, config) || bundleHasSampleInProperties(cart, config);
  }

  function pauseCartHookSync() {
    pauseCartHooks += 1;
  }

  function resumeCartHookSync() {
    pauseCartHooks = Math.max(0, pauseCartHooks - 1);
  }

  function cartFetch(url, options) {
    pauseCartHookSync();
    return fetch(url, options).finally(resumeCartHookSync);
  }

  function fetchCart() {
    return cartFetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (res) {
      return res.json();
    });
  }

  function changeLineQuantity(lineKey, quantity) {
    return cartFetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: quantity }),
    }).then(function (res) {
      if (!res.ok) return res.json().then(function (body) { throw body; });
      return res.json();
    });
  }

  function addCartItems(items) {
    return cartFetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }),
    }).then(function (res) {
      if (!res.ok) return res.json().then(function (body) { throw body; });
      return res.json();
    });
  }

  function setButtonLoading(button, loading) {
    if (!button) return;
    if (loading) {
      button.classList.add('loading');
      button.disabled = true;
    } else {
      button.classList.remove('loading');
      button.disabled = false;
    }
  }

  function removeOrphanedIngredients(cart) {
    if (processing) return Promise.resolve(cart);

    var config = getConfig();
    var ingredientsVariantId = getIngredientsVariantId(cart, config);

    if (!config || !config.enabled || !ingredientsVariantId) {
      return Promise.resolve(cart);
    }

    if (!hasVariantInCart(cart, ingredientsVariantId)) {
      return Promise.resolve(cart);
    }

    if (shouldHaveIngredients(cart, config)) {
      return Promise.resolve(cart);
    }

    var ingredientLines = lineItemsWithVariant(cart, ingredientsVariantId);
    if (!ingredientLines.length) return Promise.resolve(cart);

    processing = true;
    var chain = Promise.resolve();
    ingredientLines.forEach(function (line) {
      chain = chain.then(function () {
        return changeLineQuantity(line.key, 0);
      });
    });

    return chain
      .then(fetchCart)
      .then(function (updatedCart) {
        dispatchCartUpdated(updatedCart);
        return updatedCart;
      })
      .catch(function () {
        return cart;
      })
      .finally(function () {
        window.setTimeout(function () {
          processing = false;
        }, 400);
      });
  }


  function getBundleQuantity(cart, bundleProductId) {
    return (cart.items || []).reduce(function (total, item) {
      return item.product_id === Number(bundleProductId)
        ? total + item.quantity
        : total;
    }, 0);
  }

  function getVariantQuantity(cart, variantId) {
    return (cart.items || []).reduce(function (total, item) {
      return item.variant_id === Number(variantId)
        ? total + item.quantity
        : total;
    }, 0);
  }

  function getLeafletRequiredQty(cart, config) {
    if (!config || !config.bundleProductId) return 0;

    var bundles = bundleLinesInCart(cart, config.bundleProductId);

    return bundles.reduce(function (total, item) {
      return hasSampleInProperties(item)
        ? total + item.quantity
        : total;
    }, 0);
  }

  function processPickMixExtras(cart) {
    if (processing) return Promise.resolve(cart);


    // console.log( "START" );

    var config = getConfig();
    if (!config || !config.enabled) {
      return Promise.resolve(cart);
    }

    var bundleQty = getBundleQuantity(cart, config.bundleProductId);

    var qualifies = qualifiesForPickMix(cart, config);

    // console.log( "BUNDLE QTY: " + bundleQty );

    var currentBagQty = getVariantQuantity(
      cart,
      config.drawstringVariantId
    );

    // console.log( "BAG QTY: " + currentBagQty );

    var bagQtyToAdd =
      qualifies &&
      config.drawstringVariantId &&
      !hasUpgrade
        ? Math.max(0, bundleQty - currentBagQty)
        : 0;

    // console.log( "BAG QTY TO ADD: " + bagQtyToAdd );

    var ingredientsVariantId = getIngredientsVariantId(cart, config);
    // console.log( "1" );
    var requiredLeafletQty = getLeafletRequiredQty(cart, config);
    // console.log( "2" );
    // console.log( requiredLeafletQty );

    var currentIngredientsQty = ingredientsVariantId
      ? getVariantQuantity(cart, ingredientsVariantId)
      : 0;

    var ingredientsQtyToAdd = ingredientsVariantId
      ? Math.max(0, requiredLeafletQty - currentIngredientsQty)
      : 0;

    // console.log( "LEAFLET QTY TO ADD: " + ingredientsQtyToAdd );

    
    var hasUpgrade =
      config.washbagUpgradeVariantId && hasVariantInCart(cart, config.washbagUpgradeVariantId);

    /*
    var needsBag =
      qualifies &&
      config.drawstringVariantId &&
      !hasVariantInCart(cart, config.drawstringVariantId) &&
      !hasUpgrade;

    var ingredientsVariantId = getIngredientsVariantId(cart, config);

    var needsIngredients =
      ingredientsVariantId &&
      !hasVariantInCart(cart, ingredientsVariantId) &&
      shouldHaveIngredients(cart, config);

    if (!needsBag && !needsIngredients) return Promise.resolve(cart);

    */

    if (bagQtyToAdd === 0 && ingredientsQtyToAdd === 0) {
      return Promise.resolve(cart);
    }

    var items = [];
    if (bagQtyToAdd > 0) {
      items.push({
        id: Number(config.drawstringVariantId),
        quantity: bagQtyToAdd
      });
    }

    if (ingredientsQtyToAdd > 0) {
      items.push({
        id: Number(ingredientsVariantId),
        quantity: ingredientsQtyToAdd
      });
    }

    processing = true;

    // console.log( "END" );

    return addCartItems(items)
      .then(fetchCart)
      .then(function (updatedCart) {
        dispatchCartUpdated(updatedCart);
        return updatedCart;
      })
      .catch(function () {
        return cart;
      })
      .finally(function () {
        window.setTimeout(function () {
          processing = false;
        }, 400);
      });
  }

  function removeDrawstringBags(cart, config) {
    var lines = lineItemsWithVariant(cart, config.drawstringVariantId);
    if (!lines.length) return Promise.resolve(cart);

    var chain = Promise.resolve(cart);
    lines.forEach(function (line) {
      chain = chain.then(function () {
        return changeLineQuantity(line.key, 0).then(fetchCart);
      });
    });
    return chain;
  }

  function addCartUpsell(button) {
    if (processing) return Promise.resolve();

    var variantId = button.getAttribute('data-cart-upsell-variant-id');
    if (!variantId) return Promise.resolve();

    processing = true;
    setButtonLoading(button, true);

    return addCartItems([{ id: Number(variantId), quantity: 1 }])
      .then(fetchCart)
      .then(function (cart) {
        var config = getConfig();
        if (config && config.enabled) {
          return syncPickMixCart(cart);
        }
        return cart;
      })
      .then(function (cart) {
        dispatchCartUpdated(cart);
      })
      .catch(function (err) {
        console.error('Cart upsell add failed:', err);
      })
      .finally(function () {
        setButtonLoading(button, false);
        processing = false;
      });
  }

  function swapToWashbagUpgrade(button) {
    if (processing) return Promise.resolve();

    var config = getConfig();
    if (!config || !config.washbagUpgradeEnabled || !config.washbagUpgradeVariantId) {
      return Promise.resolve();
    }

    processing = true;
    setButtonLoading(button, true);

    return addCartItems([{ id: Number(config.washbagUpgradeVariantId), quantity: 1 }])
      .then(fetchCart)
      .then(function (cart) {
        return removeDrawstringBags(cart, config);
      })
      .then(fetchCart)
      .then(function (cart) {
        return syncPickMixCart(cart);
      })
      .then(function (cart) {
        dispatchCartUpdated(cart);
      })
      .catch(function (err) {
        console.error('Washbag upgrade failed:', err);
      })
      .finally(function () {
        setButtonLoading(button, false);
        processing = false;
      });
  }

  function syncPickMixCart(cart) {
    return removeOrphanedIngredients(cart).then(processPickMixExtras);
  }

  function fetchCartAndSync() {
    return fetchCart()
      .then(syncPickMixCart)
      .catch(function () {});
  }

  function scheduleSync(delay) {
    var wait = typeof delay === 'number' ? delay : 150;
    window.clearTimeout(debounceTimer);
    debounceTimer = window.setTimeout(fetchCartAndSync, wait);
  }

  function onCartUpdated(event) {
    if (skipNextCartUpdatedSync || processing) return;

    var cart = event && event.detail && event.detail.cart;
    if (cart) {
      syncPickMixCart(cart).then(function (updatedCart) {
        if (updatedCart && updatedCart !== cart) {
          dispatchCartUpdated(updatedCart);
        }
      });
    } else {
      scheduleSync(0);
    }
  }

  function requestUrl(input) {
    if (typeof input === 'string') return input;
    if (input && input.url) return input.url;
    return '';
  }

  function isCartMutationUrl(url) {
    return /\/cart\/(add|change|update)/i.test(url);
  }

  function hookFetch() {
    if (window.__byobPickMixFetchHooked) return;
    window.__byobPickMixFetchHooked = true;
    var originalFetch = window.fetch;
    window.fetch = function () {
      var url = requestUrl(arguments[0]);
      var promise = originalFetch.apply(this, arguments);
      if (!isCartMutationUrl(url) || pauseCartHooks > 0) return promise;
      return promise.then(function (res) {
        if (!res.ok) return res;
        return fetchCartAndSync().then(function () {
          return res;
        });
      });
    };
  }

  function hookJqueryAjax() {
    if (window.__byobPickMixJqueryHooked || !window.jQuery) return;
    window.__byobPickMixJqueryHooked = true;

    window.jQuery.ajaxPrefilter(function (options) {
      var url = options.url || '';
      if (!isCartMutationUrl(url)) return;

      var originalSuccess = options.success;
      options.success = function (data, textStatus, jqXHR) {
        fetchCartAndSync().then(function () {
          if (typeof originalSuccess === 'function') {
            originalSuccess.call(this, data, textStatus, jqXHR);
          }
        });
      };
    });

    window.jQuery(document).ajaxSuccess(function (_event, _xhr, settings) {
      if (settings.url && isCartMutationUrl(settings.url)) {
        scheduleSync(0);
      }
    });
  }

  function syncCartPage() {
    if (!isCartPage()) return;
    fetchCartAndSync();
  }

  function init() {
    var config = getConfig();

    document.addEventListener(
      'click',
      function (event) {
        var upsellBtn = event.target.closest('[data-cart-upsell-add]');
        if (upsellBtn) {
          event.preventDefault();
          event.stopPropagation();
          addCartUpsell(upsellBtn);
          return;
        }

        var upgradeBtn = event.target.closest('[data-washbag-upgrade-add]');
        if (upgradeBtn) {
          event.preventDefault();
          event.stopPropagation();
          swapToWashbagUpgrade(upgradeBtn);
          return;
        }

        if (!config || !config.enabled) return;

        var target = event.target.closest('#btn-add-to-cart, .btn-add-to-cart');
        if (target && target.closest('.byob-footer')) {
          scheduleSync(0);
        }
      },
      true
    );

    if (!config) return;

    var runExtras = config.enabled;
    var runUpgrade = config.washbagUpgradeEnabled && config.washbagUpgradeVariantId;
    if (!runExtras && !runUpgrade) return;

    document.addEventListener('cart:updated', onCartUpdated);
    document.addEventListener('cart:item-added', function () {
      scheduleSync(0);
    });
    document.addEventListener('quick-cart:open', function () {
      scheduleSync(0);
    });

    window.addEventListener('pageshow', function (event) {
      if (event.persisted || isCartPage()) syncCartPage();
    });

    hookFetch();
    hookJqueryAjax();
    syncCartPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
